
export interface RemDocsOptions {
    mode: 'fullscreen' | 'navigation';
    quickAccess : { 

    }, 
    envSettings : {
        
    }
}

export const defaults: RemDocsOptions = {
    mode: 'navigation', 
    quickAccess : { 
        
    }, 
    envSettings : {
        
    }
};
  